export default (props, traits) => {
  return {
    modal: {
      content: {
        maxWidth: traits.rhythm(20)
      }
    }
  }
}
